import { render, staticRenderFns } from "./ListLivraison.vue?vue&type=template&id=4273891c&"
import script from "./ListLivraison.vue?vue&type=script&lang=ts&"
export * from "./ListLivraison.vue?vue&type=script&lang=ts&"
import style0 from "./ListLivraison.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports